import {
  AppBar,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  IconButton,
  Toolbar
} from '@material-ui/core';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import CloseIcon from '@material-ui/icons/Close';
import { withStyles } from '@material-ui/styles';
import React, { useCallback, useEffect, useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import { Typography } from '../admin/components/Wrappers/Wrappers';
import './DocumentPreview.css';

pdfjs.GlobalWorkerOptions.workerSrc = `${process.env.PUBLIC_URL}/pdf.worker.js`;

const styles = theme => ({
  appBar: {
    position: 'relative'
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1
  }
});

const DialogTitle = withStyles(styles)(props => {
  const { children, classes, onClose, downloadPdf, ...other } = props;
  return (
    <AppBar className={classes.appBar} {...other}>
      <Toolbar>
        {onClose ? (
          <IconButton
            edge="start"
            aria-label="close"
            color="inherit"
            onClick={onClose}
          >
            <CloseIcon />
          </IconButton>
        ) : null}
        <Typography variant="h6" className={classes.title}>
          {children}
        </Typography>
        {downloadPdf && (
          <Button autoFocus color="inherit" onClick={downloadPdf}>
            Descargar
          </Button>
        )}
      </Toolbar>
    </AppBar>
  );
});

const DocumentPreview = ({ height, width, title, download, ...props }) => {
  const [currentPage, setCurrentPage] = useState(0);
  const [numPages, setNumPages] = useState(1);

  function onDocumentLoadSuccess({ numPages: nextNumPages }) {
    setNumPages(nextNumPages);
  }

  const nextPage = useCallback(
    () => {
      if (currentPage < numPages - 1) {
        setCurrentPage(currentPage + 1);
      }
    },
    [currentPage, numPages]
  );

  const previousPage = useCallback(
    () => {
      if (currentPage > 0) {
        setCurrentPage(currentPage - 1);
      }
    },
    [currentPage]
  );

  useEffect(
    () => {
      const handleKeyDown = event => {
        switch (event.key) {
          case 'ArrowUp':
            previousPage();
            break;
          case 'ArrowDown':
            nextPage();
            break;
          case 'ArrowLeft':
            previousPage();
            break;
          case 'ArrowRight':
            nextPage();
            break;
          default:
            break;
        }
      };

      // Agregar el listener
      window.addEventListener('keydown', handleKeyDown);

      // Limpiar el listener al desmontar el componente
      return () => {
        window.removeEventListener('keydown', handleKeyDown);
      };
    },
    [nextPage, previousPage]
  );

  // Función para descargar el archivo PDF
  const downloadPdf = nombreArchivo => {
    if (props.file) {
      const link = document.createElement('a');
      link.href = props.file;
      link.download = `${nombreArchivo}.pdf`; // Nombre del archivo descargado
      link.click();
    }
  };

  return (
    <Dialog
      maxWidth="lg"
      open={!!props.file}
      scroll="paper"
      fullWidth
      fullScreen
      aria-labelledby="customized-dialog-title"
      onClose={props.onClose}
    >
      <DialogTitle
        id="customized-dialog-title"
        onClose={props.onClose}
        downloadPdf={download && (() => downloadPdf(download))}
      >
        {title || 'Vista previa'}
      </DialogTitle>
      <DialogContent dividers>
        <Document
          onLoadSuccess={onDocumentLoadSuccess}
          error="No se pudo cargar el documento PDF"
          noData="No se ha especificado un PDF"
          loading={
            <div
              style={{
                height: height || 500,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <CircularProgress />
            </div>
          }
          {...props}
          className="PDFDocument"
        >
          <Page
            renderAnnotationLayer={false}
            renderTextLayer={false}
            width={width || 700}
            key={`page_${currentPage + 1}`}
            pageNumber={currentPage + 1}
            className="PDFPage"
          />
        </Document>
      </DialogContent>
      <DialogActions>
        <div style={{ textAlign: 'center', width: '100%' }}>
          <Button
            type="link"
            onClick={() => previousPage()}
            disabled={currentPage === 0}
          >
            <ChevronLeftIcon />
            Anterior
          </Button>
          <div style={{ display: 'inline', paddingLeft: 12, paddingRight: 12 }}>
            Pág. {currentPage + 1} de {numPages}
          </div>
          <Button
            type="link"
            onClick={() => nextPage()}
            disabled={currentPage + 1 === numPages}
          >
            Siguiente
            <ChevronRightIcon />
          </Button>
        </div>
      </DialogActions>
    </Dialog>
  );
};

export default DocumentPreview;
